import React from 'react'
import { Image_Url } from '../../../constants/imageUrl/ImageUrl';
import "./nopermission.scss"
import Header from '../Header/Header';

const Nopermission = () => {
  return (
    <div className="no_permission_div">
      <Header title={"No Permission"} />
      <div className='no-permission-text'>
        You don't have permission to access this page!.
      </div>
      <div className='new-req-apt-text'>
        For access connect with admin to get permissions!.
      </div>
      <div className='new-req-apt-flex'>
        <img src={Image_Url.NOTALLOWED} className="noPermission" alt='no-permission' />
      </div>
    </div>
  )
}

export default Nopermission